import { IconButton } from '@mui/material'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import styled from 'styled-components'
import React from 'react'

const ControlsContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 4px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  padding: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`

interface SectionControlsProps {
  isFirst: boolean
  isLast: boolean
  isHidden: boolean
  onMoveUp: () => void
  onMoveDown: () => void
  onToggleVisibility: () => void
}

function SectionControls({
  isFirst,
  isLast,
  isHidden,
  onMoveUp,
  onMoveDown,
  onToggleVisibility
}: Readonly<SectionControlsProps>): React.ReactElement {
  return (
    <ControlsContainer>
      <IconButton size="small" onClick={onMoveUp} disabled={isFirst} title="Move up">
        <KeyboardArrowUpIcon />
      </IconButton>
      <IconButton size="small" onClick={onMoveDown} disabled={isLast} title="Move down">
        <KeyboardArrowDownIcon />
      </IconButton>
      <IconButton size="small" onClick={onToggleVisibility} title={isHidden ? "Show section" : "Hide section"}>
        {isHidden ? <VisibilityIcon /> : <VisibilityOffIcon />}
      </IconButton>
    </ControlsContainer>
  )
}

export default SectionControls